import { StorageKeys } from 'common'
import { CxmlDetails } from '../store/models/ShoppingCartModels'

export const getCxmlDetails = (): CxmlDetails => {
  const cxmlDetails =
    localStorage.getItem(StorageKeys.CXMLDETAILS_KEY) ||
    '{"cxmlData":false,"token":""}'
  try {
    return JSON.parse(cxmlDetails)
  } catch (_error) {
    return { cxmlData: false, token: '' }
  }
}
